<!-- MESSAGE SHOW CONFORMATION-->

<section class="approve_message" *ngIf="showMessage">
    <div>
        <ul class="message_title">
            <li><img src="../../../../assets/image/error_message.svg" alt="" class="error_img"></li>
            <li>
                <h6 class="message_text">Are you sure you want to Reject?</h6>
            </li>
        </ul>
        <div>
            <h6 class="main_text">Once asset transfer rejected, this action cannot be changed.</h6>
        </div>
    </div>
    <div class="confermation">
        <button class="cancel" (click)="cancel()">CANCEL</button>
        <button class="submit" (click)="submit()">SUBMIT</button>
    </div>
</section>

<!--SUCCESS MESSAGE SHOW  -->

<section class="approve_message" *ngIf="showReject">
    <div>
        <ul class="message_title">
            <li><img src="../../../../assets/image/reject_message.svg" alt="" class="error_img"></li>
            <li>
                <h6 class="message_text">Reject</h6>
            </li>
        </ul>
        <div>
            <h6 class="main_text">The asset transfer has been rejected.</h6>
        </div>
    </div>
    <div class="confermation">
        <button class="submit" (click)="ok()">OK</button>
    </div>
</section>